import {Spec as BooleanSpec} from './PanelBoolean';
import {Spec as DateSpec} from './PanelDate';
import {Spec as NumberSpec} from './PanelNumber';
import {Spec as StringSpec} from './PanelString';
import {Spec as NullSpec} from './PanelNull';
import {Spec as StringCompareSpec} from './PanelStringCompare';
import {Spec as StringHistogramSpec} from './PanelStringHistogram';
import {Spec as MultiStringHistogramSpec} from './PanelMultiStringHistogram';
import {Spec as BarChartSpec} from './PanelBarChart';
import {Spec as HistogramSpec} from './PanelHistogram';
import {Spec as MultiHistogramSpec} from './PanelMultiHistogram';
import {Spec as ConfusionMatrixSpec} from './PanelConfusionMatrix';
import {Spec as UnknownSpec} from './PanelUnknown';
import {Spec as ImageSpec} from './PanelImage';
import {Spec as ImageCompareSpec} from './PanelImageCompare';
import {Spec as VideoSpec} from './PanelVideo';
import {Spec as AudioSpec} from './PanelAudio';
import {Spec as HTMLSpec} from './PanelHTML';
import {Spec as BokehSpec} from './PanelBokeh';
import {Spec as Object3DSpec} from './PanelObject3D';
// import {Spec as CardSpec} from './PanelCard';
// import {Spec as FacetSpec} from './PanelFacet';

import {Spec as Table2Spec} from './PanelTable2';

import {Spec as RunsPanel1Spec} from './PanelRunsPanel1';

// converters
import {Spec as MultiContainerSpec} from './PanelMultiContainer';
import {Spec as SplitCompareSpec} from './PanelSplitCompare';
// import {Spec as SplitIndependentSpec} from './PanelSplitIndependent';
import {Spec as WBObjectSpec} from './PanelWBObject';
import {Spec as MaybeSpec} from './PanelMaybe';

// files
import {Spec as FileTextSpec} from './PanelFileText';
import {Spec as FileTextDiffSpec} from './PanelFileTextDiff';
import {Spec as FileMarkdownSpec} from './PanelFileMarkdown';
import {Spec as FileRawImageSpec} from './PanelFileRawImage';
import {Spec as FileJupyterSpec} from './PanelFileJupyter';
import {Spec as DirSpec} from './PanelDir';
import {Spec as NetronSpec} from './PanelNetron';
import {Spec as WebVizSpec} from './PanelWebViz';

import {Spec as WBTableFileSpec} from './PanelWBTableFile';
import {Spec as WBJoinedTableFileSpec} from './PanelWBJoinedTableFile';
import {Spec as WBPartitionedTableFileSpec} from './PanelWBPartitionedTableFile';

// TODO: Wrap Panel components with makeSpec calls

// Note, order matters here! This is the default order in which panels
// will be recommended to the user.
export const PanelSpecs = [
  DateSpec,
  BooleanSpec,

  // strings
  StringSpec,
  StringCompareSpec,
  StringHistogramSpec,
  MultiStringHistogramSpec,

  // numbers
  NumberSpec,
  BarChartSpec,
  HistogramSpec,
  MultiHistogramSpec,

  NullSpec,

  ConfusionMatrixSpec,

  RunsPanel1Spec,

  // CardSpec,
  // FacetSpec,

  Table2Spec,
  // FacetSpec,
  // Card2Spec,

  UnknownSpec,

  // wb object files
  WBTableFileSpec,
  WBJoinedTableFileSpec,
  WBPartitionedTableFileSpec,

  // other files
  ImageSpec,
  ImageCompareSpec,
  FileJupyterSpec,
  FileRawImageSpec,
  FileMarkdownSpec,
  FileTextDiffSpec,
  FileTextSpec,
  NetronSpec,
  WebVizSpec,
  VideoSpec,
  AudioSpec,
  HTMLSpec,
  BokehSpec,
  Object3DSpec,

  // directories
  DirSpec,

  // Not enabled, it shows up too early in the list, and its not
  // that useful at the moment, since the user can't easily load
  // files with different types.
  // SplitIndependentSpec,
];

export const ConverterSpecs = [
  MultiContainerSpec,
  SplitCompareSpec,
  WBObjectSpec,
  MaybeSpec,
];
